var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"small":"","text":"","block":"","color":"grey lighten-1","outlined":_vm.outlined}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-plus")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }